<template>
    <div class="childHeader">
        <div class="header" :class="bg">
            <div class="left" @click="back">
                <img src="../assets/images/back.png" alt="后退" title="后退">
            </div>
            <div>
                <div class="title">{{ title }}</div>
                <div class="main">{{ main | thousands }}</div>
                <div v-if="subTitle" class="subTitle">{{ subTitle }}</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'child-header',
  props: {
    bg: String,
    title: String,
    subTitle: String,
    main: String
  },
  methods: {
    back () {
      this.$router.back()
    }
  }
}
</script>

<style scoped>
@media (max-width: 750px) {
  .header{
    width: 100%;
    background-size: 100% 100%;
    height: 8rem;
    box-sizing: border-box;
    padding-top: 1.22rem;
    color: #ffffff;
  }

  .blue{
      background-image: url('../assets/images/header_blue.jpg');
  }

  .yellow{
    background-image: url('../assets/images/header_yellow.jpg');
  }

  .header .left{
    width: 1rem;
    height: 1rem;
    position: absolute;
    top: 1.16rem;
    left: 0.5rem;
  }

  .header img{
    width:100%;
    height:100%;
  }

  .header .title{
    font-size: 0.64rem;
    letter-spacing: 0.012rem;
    text-align: center;
  }

  .header .main{
    font-size: 1.5rem;
    font-weight: 300;
    text-align: center;
    margin-top:1.3rem;
  }

  .header .subTitle{
    font-size: 0.52rem;
    font-weight: 300;
    text-align: center;
    margin-bottom: 1.14rem;
  }
}
@media (min-width: 750px) {
  *{
    box-sizing:border-box;
  }
  .header{
      width: 100%;
      background-size: 100% 100%;
      height: 400px;
      box-sizing: border-box;
      padding-top: 60px;
      color: #ffffff;
      font-size:24px;
  }

  .blue{
      background-image: url('../assets/images/header_blue.jpg');
  }

  .yellow{
    background-image: url('../assets/images/header_yellow.jpg');
  }

  .header .left{
    width: 50px;
    height: 50px;
    position: absolute;
    top: 65px;
    left: 25px;
    cursor: pointer;
  }

  .header img{
    width:100%;
    height:100%;
  }

  .header .title{
    font-size: 32px;
    text-align: center;
  }

  .header .main{
    font-size: 100px;
    font-weight: 300;
    text-align: center;
    margin-top:100px;
  }

  .header .subTitle{
    font-size: 26px;
    font-weight: 300;
    text-align: center;
    margin-bottom: 54px;
  }
}
</style>